export default (value) => {
  return value === true ? 'Indicate' : 'Not to indicate'
}
